import { matchPath } from 'react-router'
import { Link } from 'react-router-dom'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { useRouterPath } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { SidebarItem } from './sidebars.js'

export const MainSidebarContent = ({
  sidebar,
  onSelect,
}: {
  sidebar: SidebarItem
  onSelect: (item: SidebarItem) => void
}) => {
  const { data: network } = useNetwork()
  const pathname = useRouterPath()

  return (
    <NavVertical className="flex-grow">
      <NavVertical.Group className="flex-grow">
        {sidebar?.title && (
          <SectionHeader
            title={sidebar?.title}
            description={sidebar?.description}
            className="px-2 sm:ms-3"
          />
        )}
        <div className="pt-3 space-y-1 flex flex-col">
          {sidebar?.children?.map(item => {
            if (
              !network?.settings?.privateMessaging?.privateMessagingEnabled &&
              item?.path === adminRoutes.reports.analytics.messages
            ) {
              return null
            }

            // Check if this item should be active
            // If exact is explicitly true, only match exact paths
            // Otherwise, also match sub-routes (e.g., /manage/settings/authentication matches /manage/settings/authentication/email)
            const isExactMatch = item.exact === true
            const active =
              item.path &&
              (matchPath(
                {
                  path: item.path,
                  caseSensitive: item.exact ?? true,
                  end: isExactMatch,
                },
                pathname,
              ) ||
                // Also match if pathname starts with item.path (for sub-routes when exact is not true)
                (!isExactMatch &&
                  pathname !== item.path &&
                  pathname.startsWith(`${item.path}/`)))

            if (item?.hidden) {
              return null
            }

            return (
              <NavVertical.Item
                key={item?.key ?? item.path}
                active={!!active}
                as={item?.href ? 'a' : Link}
                to={item.path}
                href={item.href}
                leadingIcon={
                  typeof item.icon === 'string' ? (
                    <SvgIcon name={item.icon} />
                  ) : (
                    item.icon
                  )
                }
                trailingAddon={
                  item.arrow && (
                    <SvgIcon
                      className="rtl:-scale-x-100"
                      name="chevron-right"
                    />
                  )
                }
                onClick={() => {
                  if (typeof onSelect === 'function') {
                    onSelect(item)
                  }
                }}
              >
                {item.title}
              </NavVertical.Item>
            )
          })}
        </div>
      </NavVertical.Group>
    </NavVertical>
  )
}
